
import { useEffect, useState } from 'react';
import MovieCard from './MovieCard';

let apiKey="c9b12b63e552b811da26fb8ff24e14fa";
let url =`https://api.themoviedb.org/3/discover/movie?api_key=${apiKey}&language=en-US&sort_by=popularity.desc`;

const Home = () =>{
    
    const[movieData, setMovieData] = useState([]);
    const [url_set, setUrl] = useState(url);

    useEffect(()=>{
        fetch(url_set).then(res => res.json()).then(data =>{
            setMovieData(data.results);
            console.log(setUrl)
        });
    }, [url_set])

    const Filter = (event) => {
        setMovieData(movieData.filter(f => f.title.toLowerCase().includes(event.target.value)))
    }

    return(
        <>
            <div className="home">
                <nav>
                    <ul>
                        {/*movieArr.map((value) => {
                            return(
                                <li><a href='/' name={value}
                                onClick={(e)=>{getMovieData(e.target.value)}}>{value}</a></li>

                            )
                        })*/}

                        <li><a href='/'>Movies</a></li>
                        <li><a href='/login'>Login</a></li>
                        <li><a href='/register'>Register</a></li>
                    </ul>
                </nav>
                
                <form>
					<div className="search-btn">
                            <input  
                            placeholder="Search...." 
                            className="inputText"
                            onChange={Filter}

                            >
                            </input>   
                            <button><i></i></button>
                    </div>
                </form>
                
            </div>
    
            <div className="container">

                {
                    (movieData.length === 0)?<p className="notFound">Movie Not Found</p>
                    :movieData.map((res, pos) => {
                        return(
                            <>
                            <MovieCard info={res} key={pos}/>
                            </>
                            
                        )
                    })
                }
               
              {/*movieData.map((res, pos) => {
                        return(
                            <MovieCard info={res} key={pos}/>

                        )
                    })*/
                }
           

            </div>
        
        </>
    );
}

export default Home;
